<template>
  <div class="avatar-picker">
    <div class="avatar-image">
      <img :src="userAvatarLink" alt="User Avatar Image">
    </div>
    <div class="has-text-centred button-container">
      <div class="save button is-primary is-outlined is-uppercase generate-button" @click="randomAvatar"
           tabindex="0"
           @keypress.enter.space="randomAvatar">
        <span :qa="active ? 'random-avatar-btn' : ''"><i class="fas fa-random pr-1 is-size-6"></i>{{ $t("Shuffle") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'

export default {
  data: function () {
    return {
      userAvatarLink: null
    }
  },
  mounted: function () {
    this.randomAvatar()
  },
  methods: {
    randomAvatar: function () {
      const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const randomAlphabetCharacter = alphabet[Math.floor(Math.random() * alphabet.length)]
      const randomNumber = Math.floor(Math.random(100) * 1000)
      const avatarRandomString = `${randomAlphabetCharacter}-${randomNumber}`
      this.userAvatarLink = imageProxy.proxy(`https://avatars.dicebear.com/api/bottts/${avatarRandomString}.svg`, { width: 50, height: 50 })
      const avatarUrl = this.userAvatarLink
      console.log('URL = ' + avatarUrl)
      this.$emit('selectedAvatar', avatarUrl)
    },
    selectAvatar: function () {
      const avatarUrl = this.userAvatarLink
      this.$emit('selectedAvatar', avatarUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.generate-button {
  border-radius: 1px;
}
.avatar-picker {
  text-align: center;
}
.avatar-image {
  margin: 20px auto;
  padding: 10px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: #EDEDED;
}
img {
  cursor: pointer;
}
</style>
